import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  navbarFixedPositionedContent: {
    position: 'fixed',
    top: 0,
    start: 0,
    end: 0,
    zIndex: 1000
  },
  tabWrapper: {
    flex: 1
  },
  tabItem: {
    paddingLeft: 10
  },
  navbar: {
    backgroundColor: 'rgb(44, 53, 72)',
    paddingVertical: 15,
    paddingHorizontal: 0,
    position: 'fixed',
    top: 0,
    start: 0,
    end: 0,
    zIndex: 1000,
    shadowColor: 'rgba(0,0,0,0.15)',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 1,
    shadowRadius: 8,
    elevation: 8,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255,255,255,0.1)'
  },
  navContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    width: '100%'
  },
  logoContainer: {
    borderRadius: 4,
    paddingEnd: 24
  },
  leftContainer: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  desktopNavContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    justifyContent: 'space-between'
  },
  actionsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12
  },
  signOutContainer: {
    maxWidth: 100
  },
  logoImage: {
    width: 46,
    height: 46
  },
  navItemsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5
  },
  navItem: {
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 6,
    minWidth: 80,
    alignItems: 'center',
    justifyContent: 'center'
  },
  navItemInactive: {
    backgroundColor: 'transparent'
  },
  navItemActive: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    shadowColor: 'rgba(0,0,0,0.2)',
    shadowOffset: {
      width: 0,
      height: 4
    },
    shadowOpacity: 1,
    shadowRadius: 8,
    elevation: 4,
    transform: [{ translateY: -1 }]
  },
  navItemHover: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    transform: [{ translateY: -1 }]
  },
  navText: {
    color: 'rgba(255, 255, 255, 1)',
    fontWeight: '500',
    fontSize: 16,
    margin: 0
  },
  navTextActive: {
    color: '#fff',
    fontWeight: '600'
  },
  navTextHover: {
    color: '#fff'
  },
  signOutButton: {
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '4px',
    marginLeft: 20
  },
  // Mobile styles
  mobileMenuContainer: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  hamburgerButton: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: 24,
    height: 18,
    padding: 0
  },
  hamburgerLine: {
    width: '100%',
    height: 2,
    backgroundColor: '#fff',
    borderRadius: 1
  },
  mobileMenu: {
    backgroundColor: 'rgb(44, 53, 72)',
    paddingVertical: 10,
    borderTopWidth: 1,
    borderTopColor: 'rgba(255,255,255,0.1)'
  },
  mobileNavItem: {
    paddingVertical: 15,
    paddingHorizontal: 20,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255,255,255,0.1)'
  },
  mobileNavItemActive: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)'
  },
  mobileNavText: {
    color: 'rgba(255, 255, 255, 1)',
    fontWeight: '500',
    fontSize: 16,
    textAlign: 'left'
  },
  mobileSignOutContainer: {
    paddingHorizontal: 20,
    paddingVertical: 15,
    borderTopWidth: 1,
    borderTopColor: 'rgba(255,255,255,0.1)'
  },
  mobileSignOutButton: {
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    padding: '12px 16px',
    borderRadius: '4px',
    width: '100%'
  },
  chevronButton: {
    paddingHorizontal: 8,
    paddingVertical: 10,
    marginLeft: -4,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'none'
  },
  dropdownMenu: {
    position: 'absolute',
    top: 48,
    left: 0,
    backgroundColor: '#fff',
    borderRadius: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 8,
    padding: 8,
    zIndex: 2000,
    minWidth: 280,
    borderWidth: 1,
    borderColor: '#eee'
  },
  dropdownItem: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 4,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  dropdownItemHover: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)'
  },
  subDropdownMenu: {
    position: 'absolute',
    top: '100%',
    right: 0,
    backgroundColor: '#fff',
    borderRadius: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 8,
    padding: 8,
    zIndex: 2001,
    minWidth: 120,
    borderWidth: 1,
    borderColor: '#eee'
  },
  endPopupHeader: {
    padding: 24,
    paddingBottom: 12
  },
  endPopupContent: {
    flex: 1,
    borderRadius: 12,
    overflow: 'hidden',
    paddingHorizontal: 24,
    paddingBottom: 24,
    justifyContent: "space-between"
  },
  endPopupDescription: {
    color: 'rgba(0, 0, 0, 0.6)',
    lineHeight: 20
  },
  endPopupButtonsRow: {
    flexDirection: "row",
    marginTop: 32
  },
  endCancelButton: {
    flex: 1,
    marginRight: 12,
    backgroundColor: "white",
    borderWidth: 1,
    borderColor: "rgb(44, 53, 72)"
  },
  endCancelButtonText: {
    color: "rgb(44, 53, 72)"
  },
  endConfirmButton: {
    flex: 1,
    backgroundColor: "rgb(44, 53, 72)"
  },
  endConfirmButtonText: {
    color: "white"
  },
  endPopupContentPosition: {
    width: 600,
    borderRadius: 12,
    overflow: 'hidden'
  },
  endPopupBody: {
    padding: 0,
    borderRadius: 16,
    overflow: 'hidden'
  },
  filterList: {
    marginVertical: 16
  },
  filterItem: {
    marginBottom: 8
  },
  filterRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: 8,
    gap: 12
  },
  filterRowItem: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  filterRowSeparator: {
    color: 'rgba(0, 0, 0, 0.4)',
    marginHorizontal: 4
  },
  downloadButtonWrapper: {
    position: 'relative',
    flexDirection: 'row',
    alignItems: 'center'
  },
  subMenuWrapper: {
    position: 'relative'
  },
  emailInputContainer: {
    marginTop: 16,
    marginBottom: 8
  },
  emailLabel: {
    color: 'rgba(0, 0, 0, 0.75)',
    marginBottom: 4
  }
});

export default styles;
